import { z } from 'zod/v4'

// Mirrors `Store::CHECKOUT_CARD_MESSAGE_MIN_LENGTH` / `MAX_LENGTH`; 255 is the card message column size.
export const CARD_MESSAGE_LIMIT_MIN = 100
export const CARD_MESSAGE_LIMIT_MAX = 255

export const checkoutSettingsFormSchema = z.object({
  checkout_tips_enabled: z.boolean(),
  checkout_tip_split_enabled: z.boolean(),
  checkout_recipient_phone_required_for_delivery: z.boolean(),
  checkout_recipient_phone_required_for_pickup: z.boolean(),
  checkout_card_message_max_length: z
    .number()
    .int()
    .min(CARD_MESSAGE_LIMIT_MIN)
    .max(CARD_MESSAGE_LIMIT_MAX),
  product_page_all_add_ons_enabled: z.boolean(),
})

export type CheckoutSettingsFormValues = z.infer<typeof checkoutSettingsFormSchema>
